import React from "react"
import {
  FacebookShareButton,
  FacebookShareCount,
  TwitterShareButton,

} from "react-share"
import FacebookIcon from "../../assets/svg/facebook-negative-icon.inline.svg"
import TwiterIcon from "../../assets/svg/twitter-icon-small.inline.svg"
import LinkedinIcon from "../../assets/svg/linkedin-icon.inline.svg"
import {
  socialMedia,
  btnFacebook,
  btnTwitter,
  btnLinkedin,
  icon,
  btnAnchor
} from "./social-media.module.scss"
import Config from "../../../gatsby-config"

export default function Navigation(props) {
  const twitter = Config.siteMetadata.twitter
  const siteUrl = Config.siteMetadata.siteUrl
  const Title = props.title
  const Site = `${siteUrl}${props.site}`
  return (
    <div className={`${socialMedia}`}>
      {
        <span className={`${btnFacebook} `}>
          <FacebookShareButton url={Site} hashtag="#dmae">
            <FacebookIcon className={`${icon}`} viewBox="0 0 32 32" />
            <small>
              Share&nbsp;
                <FacebookShareCount url={Site} />
            </small>
          </FacebookShareButton>
        </span>
      }
      <span className={`${btnTwitter}`}>
        <TwitterShareButton
          url={Site}
          via={twitter}
          title={Title}
          hashtags={["dmae", "lsu", "lsudmae"]}
        >
          <TwiterIcon className={`${icon}`}  />
          <small>Tweet&nbsp;</small>
        </TwitterShareButton>
      </span>
      <span className={`${btnLinkedin}`}>
        <a href={`https://linkedin.com/shareArticle?url=${Site}&title=${Title}`} target="_blank" rel="noreferrer" className={btnAnchor}>
        <LinkedinIcon className={`${icon}`}/>
        <small>
          Share
        </small>
        </a>
        </span> 
    </div>
  )
}


